import React from 'react';

import { Filters, ScreenAllFilters } from 'components/Filters';
import { ScreenPresets } from 'components/Presets';

import {
  Screen,
  withScreen,
  createScreenRoute,
  useScreenState,
  useScreenDispatch,
} from '@gogame/screens';

import AllFilters from './Filters/AllFilters';
import ApplyFiltersButton from './Filters/ApplyFiltersButton';
import PrimaryFilters from './Filters/PrimaryFilters';
import RegsStatsDataTable from './RegsStatsDataTable';
import { regsStatsLink, regsStatsSearchParams } from './navigation';
import screenReducer, { APPLY, SET_FILTERS } from './reducers';
import { mapStateToPreset, EMPTY_FILTERS } from './schemas';

const id = 1086;
const permission = 96;

const SCREEN_NAME = 'regs-stats';

const RegsStats = withScreen({
  name: SCREEN_NAME,
  searchParams: regsStatsSearchParams,
  reducer: screenReducer,
})(() => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();

  const { filters } = screenState.temporary || screenState;

  const handleSetFilters = (filters) => {
    dispatch({
      type: SET_FILTERS,
      payload: filters,
    });
  };

  const handleApply = () =>
    dispatch({
      type: APPLY,
    });

  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <ScreenPresets mapStateToPreset={mapStateToPreset} />
        <Filters
          screen={SCREEN_NAME}
          controlled={true}
          initialValues={filters}
          emptyValues={EMPTY_FILTERS}
          onChange={handleSetFilters}
        >
          <PrimaryFilters />
          <ScreenAllFilters sidePage={AllFilters} />
          <Screen.Toolbar.FiltersApply>
            <ApplyFiltersButton onClick={handleApply} />
          </Screen.Toolbar.FiltersApply>
        </Filters>
        <RegsStatsDataTable />
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  id: id,
  permission: permission,
  title: 'Regs Stats',
  link: regsStatsLink,
  screen: <RegsStats />,
  disabledSchemaValidation: true,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/13024358437660-Regs-Stats',
});
